import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Foto pannello sul tetto: rossa (red/rosso), nera (black/nero), altrimenti standard.
export function roofPanelPhoto(mod) {
  const m = mod || {};
  const txt = [m.model, m.codice, m.descrizione].filter(Boolean).join(" ").toLowerCase();
  const v = /\b(red|ross[oa])\b/.test(txt) ? "rosso" : /\b(black|ner[oa])\b/.test(txt) ? "nero" : "standard";
  return `/roof-panels/${v}.png`;
}
